import { createApi } from '@reduxjs/toolkit/query/react';
import { portalBaseQuery } from '@lib/baseQuery';

/**
 * The single inventory RTK Query slice. Endpoints are injected from
 * `./inventory` via `inventoryApi.injectEndpoints` so the slice stays small
 * while sharing one reducerPath, middleware, and tag graph.
 *
 * Tag types are declared up-front (`injectEndpoints` cannot add new ones
 * later):
 * - `Inventory` — stock search results.
 * - `InventoryProducts` — the facility-grouped vendor products that seed the
 *   table rows.
 *
 * Note: the bulk-upload mutation intentionally does NOT invalidate these tags.
 * Legacy edits update local state and fire the upload fire-and-report without
 * refetching (see docs/migration/inventory/link-graph.md §12); the port keeps
 * that behavior, so the page's local working copy is the display source after
 * an edit.
 */
export const inventoryApi = createApi({
  reducerPath: 'inventoryApi',
  baseQuery: portalBaseQuery,
  tagTypes: ['Inventory', 'InventoryProducts'],
  endpoints: () => ({}),
});
